const SET_MODULE_NAME = "SET_MODULE_NAME";
const SET_SEARCH_VALUE = "SET_SEARCH_VALUE";
const SET_CATEGORY_NAME = "SET_CATEGORY_NAME";
const SET_FILTER_VALUE = "SET_FILTER_VALUE";
const SET_TYPE_VALUE = "SET_TYPE_VALUE";
const SET_TAB_POSITION = "SET_TAB_POSITION";
const SET_TAB_MNUCODE = "SET_TAB_MNUCODE";

const setModuleName = (name) => dispatch => {
    dispatch({
        type: SET_MODULE_NAME,
        name
    });
}

const setCategoryName = (name) => dispatch => {
    dispatch({
        type: SET_CATEGORY_NAME,
        name
    });
}

const setSearchValue = (value) => dispatch => {
    dispatch({
        type: SET_SEARCH_VALUE,
        value
    });
}

const setFilterValue = (value) => dispatch => {
    dispatch({
        type: SET_FILTER_VALUE,
        value
    });
}

const setTypeValue = (value) => dispatch => {
    dispatch({
        type: SET_TYPE_VALUE,
        value
    });
}

const setTabPosition = (tabPosition) => dispatch => {
    dispatch({
        type: SET_TAB_POSITION,
        position: tabPosition
    });
}

const setTabMenuCode = (tabMenuCode) => dispatch => {
    dispatch({
        type: SET_TAB_MNUCODE,
        menu: tabMenuCode
    });
}

export {
    SET_MODULE_NAME,
    SET_SEARCH_VALUE,
    SET_CATEGORY_NAME,
    SET_FILTER_VALUE,
    SET_TYPE_VALUE,
    SET_TAB_POSITION,
    SET_TAB_MNUCODE,
    setModuleName,
    setCategoryName,
    setSearchValue,
    setFilterValue,
    setTypeValue,
    setTabPosition,
    setTabMenuCode
}